import { useEffect, useState } from 'react';
import { Mic, Keyboard, X } from 'lucide-react';
import { openAssistant } from './VisitorAssistant';
import { track } from './assistantEvents';
import './assistant.css';

const SEEN_KEY = 'veluro_invite_dismissed';

/* Subtle invitation beside the hero bot. Appears once per browser session, never opens or speaks on its own. */
export const HeroInvite = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try { if (sessionStorage.getItem(SEEN_KEY)) return undefined; } catch { /* ignore */ }
    const t = setTimeout(() => { setVisible(true); track('invite_shown'); }, 1800);
    return () => clearTimeout(t);
  }, []);
  const dismiss = () => { setVisible(false); try { sessionStorage.setItem(SEEN_KEY, '1'); } catch { /* ignore */ } };
  const pick = (mode) => { dismiss(); openAssistant(mode, 'hero_invite'); };
  if (!visible) return null;
  return (
    <div data-testid="hero-invite" className="va-invite-enter relative mx-auto mt-4 sm:mt-0 sm:absolute sm:left-[calc(50%+78px)] sm:top-2 w-[330px] rounded-2xl border border-white/10 bg-[#0d0d14]/90 backdrop-blur-xl px-4 py-3 text-left shadow-xl shadow-violet-500/10">
      <span className="hidden sm:block absolute -left-1.5 top-6 h-3 w-3 rotate-45 border-l border-b border-white/10 bg-[#0d0d14]" aria-hidden="true" />
      <button type="button" onClick={dismiss} aria-label="Dismiss invitation" data-testid="hero-invite-dismiss" className="absolute right-2 top-2 text-white/30 hover:text-white/70"><X className="h-3.5 w-3.5" /></button>
      <p className="text-[13.5px] font-semibold text-white/90 pr-5">What could Veluro do for your business?</p>
      <div className="mt-2.5 flex gap-2">
        <button type="button" onClick={() => pick('voice')} data-testid="hero-invite-talk"
          className="inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-500 px-3 py-1.5 text-[12.5px] font-semibold text-white hover:brightness-110 transition-[filter]">
          <Mic className="h-3.5 w-3.5" /> Talk to Veluro
        </button>
        <button type="button" onClick={() => pick('text')} data-testid="hero-invite-type"
          className="inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-white/12 bg-white/[0.05] px-3 py-1.5 text-[12.5px] font-semibold text-white/85 hover:bg-white/[0.1] transition-colors">
          <Keyboard className="h-3.5 w-3.5" /> Type instead
        </button>
      </div>
    </div>
  );
};
